export enum StatusPedidoAtivacaoUsuario {
  PENDENTE = 'PENDENTE',
  ATIVO = 'ATIVO',
  CANCELADO = 'CANCELADO',
}
